import { ref } from 'vue'

import config from '@/config'
import { useMobile } from '@/lib/useMedia'
import type { Coordinates } from '@/types'

const isMobile = useMobile()

// I have set 'de' as default intentionally
const center = ref(
  config.settings['de'][isMobile.value ? 'mobile' : 'desktop'].center,
)

const useCenter = () => {
  return {
    updateCenter: (newCenter: Coordinates) => {
      center.value = newCenter
    },
    center,
  }
}

export default useCenter
